function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Rectangle",
  fill: "none",
  stroke: "#e4e9ee",
  strokeMiterlimit: 10,
  strokeWidth: 1
}, /*#__PURE__*/React.createElement("rect", {
  width: 193.144,
  height: 55,
  rx: 5,
  stroke: "none"
}), /*#__PURE__*/React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 192.144,
  height: 54,
  rx: 4.5,
  fill: "none"
}));

var _ref3 = /*#__PURE__*/React.createElement("text", {
  id: "Download_Google_Play",
  "data-name": "Download Google Play",
  transform: "translate(39.134 32.535)",
  fill: "#0b2136",
  fontSize: 14,
  fontFamily: "SegoeUI, Segoe UI"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 0,
  y: 0
}, "Download Google Play"));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "android",
  transform: "translate(11.015 16)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M9.655,0H.46A.46.46,0,0,0,0,.46V7.816a2.3,2.3,0,0,0,1.839,2.253v2.345a1.379,1.379,0,0,0,2.759,0v-2.3h.92v2.3a1.379,1.379,0,0,0,2.759,0V10.069a2.3,2.3,0,0,0,1.839-2.253V.46A.459.459,0,0,0,9.655,0Z",
  transform: "translate(3.678 8.277)",
  fill: "#0b2136"
}), /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M.46,7.357A.46.46,0,0,1,0,6.9,5.061,5.061,0,0,1,2.652,2.45L1.877.642A.459.459,0,0,1,2.721.28L3.5,2.09a5.009,5.009,0,0,1,3.121,0L7.394.28A.46.46,0,0,1,8.24.642L7.464,2.45A5.064,5.064,0,0,1,10.115,6.9a.46.46,0,0,1-.46.46Z",
  transform: "translate(3.678 0)",
  fill: "#0b2136"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-2",
  "data-name": "Path",
  d: "M1.379,0A1.381,1.381,0,0,0,0,1.379v4.6a1.379,1.379,0,0,0,2.759,0v-4.6A1.381,1.381,0,0,0,1.379,0Z",
  transform: "translate(14.713 8.277)",
  fill: "#0b2136"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path-3",
  "data-name": "Path",
  d: "M1.379,0A1.381,1.381,0,0,0,0,1.379v4.6a1.379,1.379,0,0,0,2.759,0v-4.6A1.381,1.381,0,0,0,1.379,0Z",
  transform: "translate(0 8.277)",
  fill: "#0b2136"
}));

function SvgAndroid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download_iMac",
    "data-name": "Download iMac",
    xmlns: "http://www.w3.org/2000/svg",
    width: 193.144,
    height: 55,
    viewBox: "0 0 193.144 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAndroid);
export default __webpack_public_path__ + "static/media/android.aeb608bc.svg";
export { ForwardRef as ReactComponent };